<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <Wxts :wxtsList="wxtsList" />

    <div class="info_form">
      <el-form ref="form" :model="form" :label-width="labelWidth" :rules="rules">
        <el-row>
          <el-col :span="8" v-for="(c, i) in certificates" :key="'certificate' + i">
            <Certificate class="self" :labelWidth="labelWidth" :viewMode="viewMode" :form="c.data" :config="c"
              :formCtrls="c.ctrls" :remindCtrl="c.remindCtrl" :options1="remindCtrlOptions1"
              :options2="remindCtrlOptions2" @onChange="onChange" @onFileChange="onFileChange" />
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="btns" v-if="certificates.length">
      <SubmitBtn @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";

let BreadCrumb = [
  { name: "车辆管理", path: `/vehicle/manage` },
  { name: "车辆列表", path: `/vehicle/manage` },
  { name: "车辆证件" },
]

let breadcrumb = [
  ...BreadCrumb,
]

export default {
  mixins: [detailMixin],
  data() {
    return {
      breadcrumb,
      wxtsList: [
        {
          name: '如需增减车辆证件类型，可以在【系统设置】【车辆证件配置】处维护。',
          // path: '/system/documentConfig',
          // pathName: '【车辆证件配置】',
          // tailName: '处维护。',
        },
      ],
      baseUrl: 'document',
      labelWidth: "180px",
      viewMode: false,
      form: {},
      rules: {},
      certificates: [],
      remindCtrlOptions1: [],
      remindCtrlOptions2: [],
      fileUploadType: 'document',
    };
  },
  methods: {
    async onFileChange({
      key,
      value: { file },
      data: { type_id },
    }) {
      console.log('onFileChange', key)
      // console.log({ ...file });
      if (file && file.raw && file.raw.type) {
        // console.log(file.raw.type)
        if (file.raw.type === 'application/pdf') {
          // 每次读取前清空，否则会重复
          this.imgUrls = []
          // pdf
          const imgUrls = await this.readPDF(file, 10)

          // console.log(this.images)
          // console.log(this.imgUrls)

          if (this.form.data && this.form.data[0]) {
            let boo = false
            this.form.data.map(o => {
              if (o.type_id === type_id) {
                o[key].push(...imgUrls)
                boo = true
              }
            })

            if (!boo) {
              const o = {
                type_id,
              }

              this.form.data.push(o)
            }
          } else {
            const o = {
              type_id,
            }

            this.form['data'] = [o]
          }
        } else {
          // 图片
          const base64str = await this.getBase64(file.raw)
          const f = await this.base64uploads(base64str)
          // console.log(f)
          if (this.form.data && this.form.data[0]) {
            let boo = false
            // 包装上传的数据
            this.form.data.map(o => {
              if (o.type_id === type_id) {
                if (o[key] && o[key].length) {
                  // o[key].push(...f)
                  console.log(o[key])
                } else {
                  this.$set(o, key, f)
                }
                boo = true
              }
            })

            // 处理回显
            this.certificates.map(o => {
              if (o.data && (o.data.type_id === type_id)) {
                // console.log({...o})
                if (o.data[key] && o.data[key].length) {
                  o.data[key].push(...f)
                } else {
                  this.$set(o.data, key, f)
                }
              }
            })
            // console.log(this.certificates)

            if (!boo) {
              const o = {
                type_id,
              }

              this.form.data.push(o)
            }
          } else {
            const o = {
              type_id,
            }

            this.form['data'] = [o]
          }
        }
      }
    },

    setValue(o, key, value) {
      // console.log(key, value)
      if (value && typeof value === 'object') {
        o[key] = value.map(v => {
          let result = v
          if (v.response && v.response.photo) {
            result = { url: v.response.photo }
          }
          return result
        })
      } else {
        o[key] = value;
      }
    },
    onChange({ key, value, data: { type_id } }) {
      // console.log(key, value, type_id)
      if (this.form.data && this.form.data[0]) {
        let boo = false
        this.form.data.map(o => {
          if (o.type_id === type_id) {
            this.setValue(o, key, value)
            boo = true
          }
        })
        if (!boo) {
          const o = {
            type_id,
          }
          this.setValue(o, key, value)
          this.form.data.push(o)
        }
      } else {
        const o = {
          type_id,
        }
        this.setValue(o, key, value)
        this.form['data'] = [o]
      }
      // console.log({ ...this.form });
    },
    setData(list) {
      this.$set(this.form, 'data', [])
      list.map(v => {
        const { type_name } = v
        const dt = { ...v }
        delete dt.type_name
        this.form.data.push(dt)
        const o = {
          label: type_name + '',
          data: v,
          ctrls: [
            {
              label: "上传图片",
              keyName: "image",
              type: "file",
              ptype: "document",
              tips: "最多上传10张图片",
              accept: '.png, .jpg, .jpeg, .pdf',
              max: 10,
            },
            {
              label: "到期时间",
              keyName: "maturitytime",
              err: "请选择时间",
              type: "date",
            },
          ],
          remindCtrl: {
            label: "提醒时间",
            key1: "pronum",
            key2: "reminder",
          },
        }
        this.certificates.push(o)
      })
      console.log(list)
      console.log(this.certificates)
    },
    getData(params = {}) {
      this.post(`${this.baseUrl}/rec`, params, (res) => {
        console.log(res)
        const { list, tanday, interday } = res
        if (list && list.length) {
          this.setData(list)
        } else if (list.length == 0) {
          this.$message({
            type: 'error',
            message: '暂无数据,请前往【系统设置】【车辆证件配置】处维护',
          });
        } else {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
        }
        if (tanday && tanday.length) {
          this.remindCtrlOptions1 = tanday.map((val) => {
            return {
              label: val.name,
              value: val.intime,
            };
          });
        }
        if (interday && interday.length) {
          this.remindCtrlOptions2 = interday.map((val) => {
            return {
              label: val.name,
              value: val.intime,
            };
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    specialParamsPackage(params) {
      if (this.carid) {
        params['carid'] = this.carid
      }
      if (this.car_type) {
        params['car_type'] = this.car_type
      }
      console.log({ ...params })
    },
    getKeys() {
      const arr = ['data']
      return arr
    },
    cancel() {
      this.$router.back();
    },
    setQueryParams() {
      const { carid, car_type, license } = this.$route.query;
      const params = {}
      if (carid) {
        params['carid'] = carid
        this['carid'] = carid
      }
      if (car_type) {
        params['car_type'] = car_type
        this['car_type'] = car_type
      }
      if (license) this.breadcrumb[2].name = `${license}车辆证件`
      return params
    },
  },
  created() {
    const params = this.setQueryParams()
    this.getData(params)
  },
  async mounted() {
    // 动态加载 pdf.js
    await this.loadPdfJs();
  },
  beforeRouteEnter(to, from, next) {
    // console.log(from)
    if (from.path.includes('/vehicle/hang')) {
      breadcrumb[0] = { name: "车辆管理", path: `/vehicle/hang` }
      breadcrumb[1] = { name: "挂车管理", path: `/vehicle/hang` }
    } else if (from.path.includes('/documents/list')) {
      breadcrumb[0] = { name: "车辆管理", path: `/vehicle/documents/list` }
      breadcrumb[1] = { name: "临期查询", path: `/vehicle/documents/list` }
    } else {
      breadcrumb[0] = BreadCrumb[0]
      breadcrumb[1] = BreadCrumb[1]
    }
    next()
  },
};
</script>

<style lang="less" scoped>
/deep/ .info_form {
  padding: 0;
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);

  .el-form {
    .el-form-item {
      padding: 0 20px 0 0;
      margin-bottom: 20px;

      .el-input,
      .el-textarea {
        width: 300px;
      }

      .el-upload__tip {
        left: 107px;
        top: 2px;
        width: 180px;
      }

      .el-button--small {
        // padding: 12px 21px;
        font-size: 14px;
      }
    }

    .subform {
      &::before {
        width: 110%;
        height: 10px;
        background: #f9f9f9;
        content: "";
      }

      &:first-child {
        &::before {
          display: none;
        }
      }
    }
  }
}

.info_form {
  /deep/ .el-form {
    .el-form-item.remind .content {
      display: block;

      .left:nth-child(2) {
        margin-left: 180px;
        margin-top: 20px;
      }
    }

    .el-row {
      overflow: hidden;

      .el-col:nth-child(3n+1) {
        clear: left;
      }
    }
  }

}

.instyle {
  display: inline-block;
}

.bainfo {
  padding-bottom: 20px;
}

.info_form .el-form .subform {
  margin-bottom: 0;
}

/*.info_form .el-form .el-form-item:nth-child(9) {
  display: block;
}*/
/deep/ .el-form .el-form-item.remind .content {
  display: block;

  .left:nth-child(2) {
    margin-left: 180px;
    margin-top: 20px;
  }
}

/deep/ .self {
  >.el-form-item__label {
    float: none !important;
    display: block;
    margin: 39px 0 18px 112px;
    text-align: left;
    font-size: 18px;
    color: #333;
  }

  >.el-form-item__content {
    margin-left: 0 !important;
  }
}

.el-form .el-row:nth-child(4) .el-col-8 .subform::before {
  display: none;
}

.el-form .el-row:nth-child(4) .el-col-16 .subform::before {
  display: none;
}

.el-col-16 .self {
  margin-left: -54px;
}

.el-row .el-col .self:first-child {
  margin-bottom: 40px;
}

/deep/.info_form .el-form .el-row:nth-child(2) {
  padding-bottom: 20px;
}

/deep/ .subform .el-row .el-col-8 .el-form-item:last-child {
  margin-bottom: 40px;
}

.tit_label {
  margin: 26px 0 26px 112px;
  font-size: 18px;
  color: #333;
}

/deep/.el-icon-arrow-right:before {
  content: "";
}

/deep/ .breadcrumb .el-icon-arrow-right:before {
  content: "\e6e0";
}

.btns {
  margin: 40px 0 60px 180px;
}
</style>
